import { FC } from 'react';
import { Button } from 'antd';
import cs from 'classnames';
import type { ButtonProps } from 'antd/lib/button';
import styles from './index.module.scss';

export const ButtonCore: FC<ButtonProps> = ({
  className,
  children,
  ...props
}) => {
  return (
    <Button className={cs([styles['button'], className])} {...props}>
      {children}
    </Button>
  );
};

export default ButtonCore;
